import getNestedProperty from '../GetNestedProperty'

const BLOCK_TAGS = [
  'address',
  'blockquote',
  'br',
  'div',
  'dl',
  'fieldset',
  'form',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'hr',
  'li',
  'p',
  'pre',
  'table',
]

const isBlock = (node) => {
  let tag = getNestedProperty(node, 'tagName') || ''
  tag = tag.toLowerCase()
  return BLOCK_TAGS.indexOf(tag) !== -1
}

export default isBlock
